import React from "react"
import classnames from "classnames/bind"

import TopTitle from "@components/TopTitle"
import AnchorButton from "@components/CTAAnchorButton"
import styles from "./BannerHome.module.scss"

const Article = props => {
  return (
    <article className={styles.article + " text-center text-lg-left pr-lg-5"}>
      <h1
        className={classnames(
          styles.title,
          "proxima-nova--extra-bold",
          "fs-30pt",
          "text-white",
          "mb-5",
          "fs-lg-40pt",
          "fs-xl-50pt"
        )}
      >
        <TopTitle content="SIMPLICITY, SECURITY AND FLEXIBILITY" /> CONNECT {props.pathContext.appName.toUpperCase()} WITH ASSERTIV
      </h1>
      <p
        className={
          styles.description +
          " fs-18pt fs-xl-23pt text-white proxima-nova--light"
        }
      >
        {props.pathContext.appName} is just one of many applications which are supported out of the box with your EngineID solution.
      </p>
      <AnchorButton
        href="/demo"
        content="SEE A DEMO"
        className={styles.button}
      />
    </article>
  )
}

export default Article
